import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Styles from "../../styles/client/profile.module.scss";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { clientRoutes } from "../../routers/ClientRouters";
import { getClientProfile } from "../../services/clientService";

const Profile = () => {
  const { isLoading, profile } = useSelector((state) => state.client);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(clientRoutes.dashboard);
  };
  useEffect(() => {
    getClientProfile();
  }, []);
  const handleEdit = () => {
    navigate(clientRoutes.editprofile);
  };

  return (
    <>
      <Navbar />
      <div className={Styles.exercise_list_container_main}>
        <h2>
          <Link to={clientRoutes.dashboard}>HOME / </Link>
          <span>PROFILE</span>
        </h2>
        <div className={Styles.exercise_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <h3>PROFILE</h3>
            </div>
          </div>
          <div className={Styles.borderbottomline}></div>

          <div className={Styles.renderedcontentmaindiv}>
            {isLoading ? (
              <div className={Styles.loading_container}>
                <p>Loading...</p>
              </div>
            ) : profile ? (
              <div className={Styles.contentdata}>
                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>ID</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.code || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Name</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.name || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Gender</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.gender || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>DOB</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.dob || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Email ID</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.email || ""}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Password</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.password || "*********"}</span>
                  </div>
                </div>

                <div className={Styles.contentitem}>
                  <div className={Styles.contentitemboxone}>
                    <strong>Phone</strong>
                  </div>
                  <div className={Styles.contentitemboxtwo}>
                    <span>{profile?.phone || ""}</span>
                  </div>
                </div>
              </div>
            ) : (
              <div className={Styles.no_data_container}>
                <p>No profile available.</p>
              </div>
            )}
          </div>
          <div className={Styles.borderbottomline}></div>

          <div className={Styles.borderbottommainbutton}>
            <button onClick={handleEdit} className={Styles.edit_btn}>
              Edit
            </button>
            <button onClick={handleBack} className={Styles.back_btn}>
              Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
